import { Component, OnInit } from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-modal-resend-code',
  templateUrl: './modal-resend-code.component.html',
  styles: []
})
export class ModalResendCodeComponent extends ExcTranslation implements OnInit {

  data = {Sel: 1, DifferentMail: null};
  constructor(private overlayConfig: OverlayConfig, private overlayRef: OverlayRef) {
    super();
  }

  proceed(result) {
    this.overlayRef.close({proceed: result, Mail: this.data.Sel === 1  ? this.overlayConfig.data.DealerMail : this.data.DifferentMail});
  }
  handleChange(e) {
    this.data.Sel = e.value;
  }
  ngOnInit() {
  }

}
